export const normalizeServiceType = (serviceType: string | undefined | null) =>
  String(serviceType || "").toLowerCase().trim().replace(/\s+/g, "");

export const getBaseServiceType = (serviceType: string | undefined | null) => {
  const rawValue = String(serviceType || "").toLowerCase().trim();
  return rawValue.replace(/_(primary|secondary)\d*$/, "");
};

export const getUniqueServiceType = (
  baseType: string,
  rowIndex: number,
  services: Array<{ type?: string | null }> = [],
) => {
  const normalizedBaseType = getBaseServiceType(baseType);
  if (!normalizedBaseType) return baseType;

  const usedTypes = new Set(
    services
      .filter((_service, idx) => idx !== rowIndex)
      .map((service) => normalizeServiceType(service?.type || ""))
      .filter(Boolean),
  );

  if (!usedTypes.has(normalizedBaseType)) {
    return normalizedBaseType;
  }

  const primaryCandidate = `${normalizedBaseType}_primary`;
  if (!usedTypes.has(primaryCandidate)) {
    return primaryCandidate;
  }

  let candidate = `${normalizedBaseType}_secondary`;
  let suffix = 2;
  while (usedTypes.has(candidate)) {
    candidate = `${normalizedBaseType}_secondary${suffix}`;
    suffix += 1;
  }

  return candidate;
};
